import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WeeksService, Week } from 'src/app/services/weeks.service';
import { FillReport, FillReportRow, FillStatus, WeeklyPlansService } from 'src/app/services/weekly-plans.service';

@Component({
  selector: 'app-fill-dashboard',
  templateUrl: './fill-dashboard.component.html',
  styleUrls: ['./fill-dashboard.component.css']
})
export class FillDashboardComponent implements OnInit {
  weeks: Week[] = [];
  weekOrdinal = 1;
  loading = true;
  report: FillReport | null = null;
  errorMessage = '';
  statusFilter: FillStatus | 'all' = 'all';
  search = '';

  constructor(
    private weeksService: WeeksService,
    private weeklyPlansService: WeeklyPlansService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  get weekOptions(): Week[] {
    return this.weeks;
  }

  get filteredRows(): FillReportRow[] {
    const rows = this.report?.rows || [];
    const q = this.search.trim().toLowerCase();
    return rows.filter(row => {
      if (this.statusFilter !== 'all' && row.status !== this.statusFilter) {
        return false;
      }
      if (!q) {
        return true;
      }
      return [row.teacherName, row.className, row.subjectName]
        .join(' ')
        .toLowerCase()
        .includes(q);
    });
  }

  ngOnInit(): void {
    void this.init();
  }

  async init(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';
    try {
      this.weeks = await this.weeksService.list();
      const options = this.weekOptions;
      if (options.length) {
        const preferred = options.find(week => week.active) || options[0];
        this.weekOrdinal = preferred.ordinal;
      }
      await this.loadReport();
    } catch (error: any) {
      this.errorMessage = error?.error?.errorMessages?.[0]?.message || 'DASHBOARD.LOAD_FAILED';
    } finally {
      this.loading = false;
    }
  }

  async onWeekChange(): Promise<void> {
    await this.loadReport();
  }

  async loadReport(): Promise<void> {
    if (!this.weekOrdinal) {
      return;
    }
    this.loading = true;
    this.errorMessage = '';
    try {
      this.report = await this.weeklyPlansService.getFillReport(this.weekOrdinal);
    } catch (error: any) {
      this.report = null;
      this.errorMessage = error?.error?.errorMessages?.[0]?.message || 'DASHBOARD.LOAD_FAILED';
    } finally {
      this.loading = false;
    }
  }

  statusLabelKey(status: FillStatus): string {
    return `DASHBOARD.STATUS_${status.toUpperCase()}`;
  }

  setFilter(status: FillStatus | 'all'): void {
    this.statusFilter = status;
  }

  openPlan(row: FillReportRow): void {
    void this.router.navigate(['../weekly-plans'], {
      relativeTo: this.route,
      queryParams: {
        class: row.classId,
        week: this.weekOrdinal,
        subject: row.subjectId,
      },
    });
  }
}
